import { createFileRoute, Link } from "@tanstack/react-router";
import { LegalPage } from "../components/legal-page";

export const Route = createFileRoute("/legal/accessibility")({
  head: () => ({
    meta: [
      { title: "Accessibility Statement" },
      { name: "description", content: "Our accessibility commitment, conformance status under WCAG 2.1 AA, and how to report issues." },
      { property: "og:title", content: "Accessibility Statement" },
      { property: "og:url", content: "https://www.hrservicecentre.co.uk/legal/accessibility" },
    ],
    links: [{ rel: "canonical", href: "https://www.hrservicecentre.co.uk/legal/accessibility" }],
  }),
  component: AccessibilityPage,
});

function AccessibilityPage() {
  return (
    <LegalPage
      title="Accessibility Statement"
      intro="We want everyone to be able to use the HR Service Centre website, regardless of ability or assistive technology."
      lastReviewed="2026-09-14"
    >
      <h2>Conformance</h2>
      <p>
        This site aims to conform with the Web Content Accessibility Guidelines (WCAG) 2.1 at level AA. We test with
        keyboard navigation, screen readers and automated tools as part of our release process.
      </p>

      <h2>What we do</h2>
      <ul>
        <li>Semantic HTML, single H1 per page, descriptive headings.</li>
        <li>Visible focus states and full keyboard support.</li>
        <li>Alt text on meaningful images.</li>
        <li>Sufficient colour contrast in both light and dark contexts.</li>
        <li>Forms with labels, error messages and ARIA where appropriate.</li>
        <li>Calculators and interactive tools operable without a mouse.</li>
      </ul>

      <h2>Documents and downloads</h2>
      <p>
        Our templates are provided as Word, Excel and PDF files. If you need one in a different or more accessible
        format, tell us and we'll provide an alternative.
      </p>

      <h2>Known issues</h2>
      <p>
        We're aware that some embedded third-party content, including mapping and partner material, may not fully meet
        our standard. We're working with suppliers to improve this.
      </p>

      <h2>Reporting a problem</h2>
      <p>
        If you find something hard to use, tell us through our{" "}
        <Link to="/contact-hr-experts">contact form</Link> and we'll aim to respond within 5 working days. You can also
        write to us at HR Service Centre, 20-22 Wenlock Road, London, N1 7GU.
      </p>
    </LegalPage>
  );
}
